import { useContext } from 'react';
import { RoutesStore } from '../context';
import { RouteItem } from '../routes/RouteItem';

export function useIsPageHidden(
  page:
    | 'Account'
    | 'Business'
    | 'Payments'
    | 'Business Owner/Financial'
    | 'Documents/Statements',
) {
  const { sidebarRoutes } = useContext(RoutesStore);
  // the RoutesContext already handles sidebar route (page) visibility
  // so we can just rely on the existing logic to check if we should display this page
  return !(sidebarRoutes as RouteItem[]).some(sr => sr.title === page);
}
